export default __webpack_public_path__ + "static/media/EMprint Regular.93ea1717.svg";